import { FC, ReactNode } from 'react'
import { Row } from 'antd'
import { PerSpacerProps } from '../Spacer'
import { marginClasses } from '../../util/less-util'
import { FlexJustify } from '../../util/types'
import { Gutter } from 'antd/lib/grid/row'

import './index.less'

const antdAlignToRealWorldCssAlign = (antdAlign: string): string => {
  if (antdAlign === 'top') return 'flex-start'
  if (antdAlign === 'middle') return 'center'
  if (antdAlign === 'bottom') return 'flex-end'
  return 'center' // fallback
}

export interface PerFlexRowProps extends PerSpacerProps {
  children: ReactNode
  align?: 'top' | 'middle' | 'bottom' // should be the same as Antd Row !
  justify?: FlexJustify
  direction?: 'row' | 'column'
  className?: string
  noWrap?: boolean
  scrollX?: boolean
  width?: 'fullWidth' | string
  gutter?: Gutter
}

const PerFlexRow: FC<PerFlexRowProps> = ({
  children,
  align,
  justify,
  direction,
  m,
  mx,
  my,
  mt,
  mr,
  mb,
  ml,
  className,
  noWrap,
  scrollX,
  width,
  gutter = 0,
}) => {
  const base = 'per-flexRow'
  const modifiers = marginClasses(m, mb, mt, ml, mr, mx, my, 'per-spacer')

  if (noWrap) {
    modifiers.push(base + '--noWrap')
  }
  if (className) {
    modifiers.push(className)
  }
  if (width === 'fullWidth') {
    modifiers.push(width)
  }

  // Direction = Row
  if (direction !== 'column') {
    return (
      <Row
        style={{ overflowX: scrollX ? 'auto' : 'initial', width: width !== 'fullWidth' ? width : undefined }}
        type="flex"
        align={align}
        justify={justify}
        className={base + ' ' + modifiers.join(' ')}
        gutter={gutter}
      >
        {children}
      </Row>
    )
  } else {
    // Direction = column
    return (
      <div
        className={base + ' ' + modifiers.join(' ')}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: justify ? justify : 'start',
          alignItems: align ? antdAlignToRealWorldCssAlign(align) : 'top',
          width: width !== 'fullWidth' ? width : undefined,
        }}
      >
        {children}
      </div>
    )
  }
}

export default PerFlexRow
